"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownFilterPipe = void 0;
class DropdownFilterPipe {
    transform(items, filter, defaultFilter, featureId) {
        if (!filter) {
            return items;
        }
        if (!Array.isArray(items)) {
            return items;
        }
        const filterKeys = Object.keys(filter);
        if (defaultFilter) {
            return items.filter((item) => filterKeys.reduce((x, keyName) => x && this.matchesFilter(item, filter[keyName], keyName, featureId), true));
        }
    }
    getValue(item, keyName, featureId) {
        if (keyName === 'profileRole') {
            if (item.hasProfile !== 'yes') {
                return 'No Profile';
            }
            else if (!item.roles || item.roles.length === 0) {
                return 'Unassigned';
            }
            else {
                return this.cleanString(item.roles.join(', '));
            }
        }
        if (keyName === 'fullDeviceName' && item.device) {
            const deviceName = item.device.deviceName || '';
            const displayName = item.device.displayName || '';
            return this.cleanString(deviceName + ' ' + displayName);
        }
        const keys = keyName.split('.');
        if (keys !== null && keys.length > 1 && typeof item[keys[0]] === 'object') {
            let obj = item[keys[0]];
            // code for filtering data priority feature
            if (obj && Array.isArray(obj)) {
                obj = obj.filter((objItem) => objItem.featureID === featureId);
                obj = obj[0];
            }
            if (obj) {
                return this.cleanString(obj[keys[1]]);
            }
            else {
                return;
            }
        }
        else if (item[keyName] !== null && item[keyName] !== undefined) {
            return this.cleanString(item[keyName]);
        }
    }
    matchesFilter(item, filterValue, keyName, featureId) {
        const cleanedFilterValue = this.cleanString(filterValue);
        const escapedFilter = this.escapeRegExp(cleanedFilterValue);
        const itemValue = this.getValue(item, keyName, featureId);
        return cleanedFilterValue === '' || (itemValue ? new RegExp(escapedFilter, 'gi').test(itemValue) : false);
    }
    cleanString(text) {
        return !text ? '' : text.replace(/[&\\#,+()$~%.'":*?<>{}-]/g, '');
    }
    escapeRegExp(text) {
        return !text ? '' : text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    }
}
exports.DropdownFilterPipe = DropdownFilterPipe;
//# sourceMappingURL=dropdownfilter.pipe.js.map